import { apiCall } from '../../API';

function memoizePromise(fn) {
    let promise = null;
    return (...args) => {
        if (!promise) {
            promise = fn(...args).finally(() => {
                promise = null;
            });
        }
        return promise;
    };
}

const apiLoad = memoizePromise(apiCall('/console/custom_pages/list'));
const apiUpdate = apiCall('/console/custom_pages/save');

export default function getCustomPagesApis(type) {
    return {
        apiLoad: (...args) => apiLoad(...args).then((result) => {
            const cp = result.find((x) => x.type === type);
            return cp ? {
                enabled: cp.enabled,
                ...JSON.parse(cp.content),
            } : {};
        }),
        apiUpdate: ({ enabled, ...content }) => {
            return apiUpdate({
                type,
                enabled,
                content: JSON.stringify(content),
            });
        },
    };
}
